// src/components/ManageFields.jsx
import React, { useState, useEffect } from 'react';
import { useFieldDefs } from '../../hooks/useFieldDefs';
import { createField } from '../../services/api';

export default function ManageFields() {
    // 1) Leemos definiciones, loading y error
    const { fieldDefs, loading, error } = useFieldDefs();

    // 2) State local que podremos mutar con setLocalDefs
    const [localDefs, setLocalDefs] = useState([]);

    // 3) Cuando llegue fieldDefs, lo volcamos en localDefs
    useEffect(() => {
        if (Array.isArray(fieldDefs)) {
            setLocalDefs(fieldDefs);
        }
    }, [fieldDefs]);

    // 4) Campos de formulario
    const [label, setLabel] = useState('');
    const [keyName, setKeyName] = useState('');
    const [type, setType] = useState('checkbox');
    const [options, setOptions] = useState('');

    // 5) Al enviar, creamos el campo y lo añadimos al array
    const addField = async e => {
        e.preventDefault();
        const opts = type === 'select' ? options.split(',').map(s => s.trim()) : [];
        try {
            const result = await createField({ label, key: keyName, type, options: opts });
            // createField puede devolver la respuesta de axios o el JSON directamente
            const newField = result.data ?? result;
            setLocalDefs(prev => [...prev, newField]);
            // reset form
            setLabel('');
            setKeyName('');
            setType('checkbox');
            setOptions('');
        } catch (err) {
            console.error('Error creando campo:', err);
        }
    };

    if (loading) return <div>Cargando campos personalizados…</div>;
    if (error) return <div>Error cargando campos: {error.message}</div>;

    return (
        <div>
            <h2>Administrar Campos</h2>
            <form onSubmit={addField}>
                <input
                    placeholder="Etiqueta (label)"
                    value={label}
                    onChange={e => setLabel(e.target.value)}
                    required
                />
                <input
                    placeholder="Clave BD (key)"
                    value={keyName}
                    onChange={e => setKeyName(e.target.value)}
                    required
                />
                <select value={type} onChange={e => setType(e.target.value)}>
                    <option value="text">Texto</option>
                    <option value="number">Número</option>
                    <option value="date">Fecha</option>
                    <option value="checkbox">Checkbox</option>
                    <option value="select">Select</option>
                </select>
                {type === 'select' && (
                    <input
                        placeholder="Opciones (coma separadas)"
                        value={options}
                        onChange={e => setOptions(e.target.value)}
                    />
                )}
                <button type="submit">Agregar campo</button>
            </form>

            <ul>
                {localDefs.map(def => (
                    <li key={def._id ?? def.key}>
                        {def.label} — <code>{def.key}</code> — {def.type}
                    </li>
                ))}
            </ul>
        </div>
    );
}
